import React from "react";

import styled from "styled-components/macro";

const Container = styled.div`
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme["@grey"]};
  flex: 1;
`;

const Content = styled.div`
  box-shadow: 0px 3px 12px #00000029;
  margin: 16px;
  padding: 24px;
  background: ${({ theme }) => theme["@light"]};
  border-top: 2px solid ${({ theme }) => theme["@primary"]};
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
`;

const Centered = ({ children, contentStyle = {} }) => {
  return (
    <Container>
      <Content style={contentStyle}>{children}</Content>
    </Container>
  );
};

export default Centered;
